import React from 'react'

const DoiteasyLogo = () => {
  return (
    <h1 className="text-[40px] -tracking-[0.05em] font-[600] text-doiteasy-blue font-space-grotesk text-center mx-auto">doiteasy</h1>
  )
}

export default DoiteasyLogo